<div
  class="fixed right-0 bottom-0 flex w-[calc(100%-256px)] justify-end-safe border-t border-l border-(--p-drawer-border-color) p-4 [background:linear-gradient(270deg,#1a2841_0%,#141619_100%)]"
>
  <div
    [ngClass]="{ 'mr-94.75': isDrawerOpen(), 'mr-19.25': !isDrawerOpen() }"
    class="transition-margin flex gap-2 duration-300"
  >
    @for (item of items; track item.label) {
      <p-button
        [severity]="item.severity"
        [disabled]="item.disabledFunction ? item.disabledFunction() : false"
        [loading]="item.loadingFunction ? item.loadingFunction() : false"
        (onClick)="item?.action()"
        class="gap-4 rounded-md border border-[#25CDFF] [&_.p-button-label]:ml-2"
        [styleClass]="item.styleClass"
        [label]="item.label"
      >
        @if (!item.loadingFunction || !item.loadingFunction()) {
          <span class="inline-flex h-4 w-4 items-center justify-center">
            <nsp-icon [name]="item.icon" />
          </span>
        }
      </p-button>
    }
    <p-dialog
      header="Delete Report?"
      [modal]="true"
      [(visible)]="isDeleteDialogVisible"
      [style]="{ width: '25rem' }"
    >
      <div class="mb-8 block">Are you sure you want to delete this report?</div>
      <div class="mb-8 block">This cannot be undone.</div>
      <div class="flex justify-end gap-2">
        <p-button
          label="Cancel"
          severity="secondary"
          (click)="isDeleteDialogVisible = false"
        />
        <p-button
          label="Delete Report"
          (click)="deleteReport()"
        />
      </div>
    </p-dialog>
  </div>
</div>
